import React from 'react';
import { howItWorksData } from '../mock/programsData';

const stepColors = [
  'from-pink-300 to-pink-400 text-pink-900',
  'from-purple-300 to-purple-400 text-purple-900',
  'from-blue-300 to-blue-400 text-blue-900',
  'from-yellow-300 to-yellow-400 text-yellow-900'
];

const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-20 bg-gradient-to-br from-purple-50 via-blue-50 to-green-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-purple-600 mb-4">
            {howItWorksData.title}
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          {howItWorksData.steps.map((step, i) => (
            <div
              key={step.number}
              data-testid={`how-step-${i + 1}`}
              className="relative bg-white border-3 border-purple-200 rounded-3xl p-6 shadow-md hover:shadow-2xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className={`w-16 h-16 mb-5 rounded-2xl bg-gradient-to-br ${stepColors[i]} flex items-center justify-center font-extrabold text-xl shadow-lg`}>
                {step.number}
              </div>
              <h3 className="text-lg font-bold text-purple-700 mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
